module.exports = __webpack_public_path__ + "static/insalata200-9dfc9bd666e04da133ffabebf2e46e90.png";